var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'checkbox-label',
    {
      'checkbox-label_active': _vm.value,
      'checkbox-label_active-secondary': _vm.value && _vm.color === 'secondary',
      'checkbox-label_active-muted': _vm.value && _vm.color === 'muted',
    } ],attrs:{"for":_vm.id}},[_c('input',{staticClass:"checkbox-input",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_vm._v("\n  "+_vm._s(_vm.labelText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }